/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseAction from './CloseAction/index'
import React from 'react'
import Steps from './Steps/index'
import Title from './Title/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 height={600}
 width={720}
 dangerouslyBypassFocusLock={true}
 borderBottomLeftRadius={dtSpaceXs}
 borderBottomRightRadius={dtSpaceXs}
 borderTopLeftRadius={dtSpaceXs}
 borderTopRightRadius={dtSpaceXs}
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<Title
{...childProps}
  viewPath={`${viewPath}/Title`}
/>
<CloseAction
{...childProps}
  viewPath={`${viewPath}/CloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<Steps
{...childProps}
  viewPath={`${viewPath}/Steps`}
/>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}